import request from '@/utils/request'
import store from '../store'
export function GetDoctorSchcedule() {
  return request({
    url: 'Common/GetDoctorSchcedule',
    method: 'get',
    params: { departId: store.getters.departId }
  })
}
export function PostDoctorSchcedule(datas) {
  return request({
    url: 'Common/PostDoctorSchcedule',
    method: 'post',
    data: datas
  })
}
export function GetDoctorScheduleSheet() {
  return request({
    url: 'Common/GetDoctorScheduleSheet',
    method: 'get',
    params: { departId: store.getters.departId, fileName: '' }
  })
}
export function CreateOrUpdateDeviceType(datas) {
  return request({
    url: 'DeviceType/CreateOrUpdateDeviceType',
    method: 'post',
    data: datas
  })
}
export function CreateOrUpdateDevice(datas) {
  return request({
    url: 'Device/CreateOrUpdateDevice',
    method: 'post',
    data: datas
  })
}
export function CreateOrUpdateProcedureCode(datas) {
  return request({
    url: 'ProcedureCode/CreateOrUpdateProcedureCode',
    method: 'post',
    data: datas
  })
}
export function CreateOrUpdateBodyGroup(datas) {
  return request({
    url: 'PartGroup/CreateOrUpdateBodyGroup',
    method: 'post',
    data: datas
  })
}
export function GetModalityTypes() {
  return request({
    url: 'Common/GetModalityTypes',
    method: 'get'
  })
}
export function GetProcedureCodes(datas) {
  return request({
    url: 'ProcedureCode/GetProcedureCodes',
    method: 'post',
    data: datas
  })
}
export function GetModuleList() {
  return request({
    url: 'Common/GetModuleList',
    method: 'get'
  })
}
export function CreateOrUpdateRole(datas) {
  return request({
    url: 'Common/CreateOrUpdateRole',
    method: 'post',
    data: datas
  })
}
export function GetRoles() {
  return request({
    url: 'Common/GetRoles',
    method: 'get'
  })
}
export function GetUserList(datas) {
  return request({
    url: 'User/GetUserList',
    method: 'post',
    data: datas
  })
}
export function CreateOrUpdateUser(datas) {
  return request({
    url: 'User/CreateOrUpdateUser',
    method: 'post',
    data: datas
  })
}
export function GetHospitalInfo() {
  return request({
    url: 'Hospital/GetHospitalInfo',
    method: 'get',
    params: { hospId: store.getters.currentUserRoleDepart.hospId }
  })
}
export function CreateOrUpdateHospital(datas) {
  return request({
    url: 'Hospital/CreateOrUpdateHospital',
    method: 'post',
    data: datas
  })
}

